import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import { getContent } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import WhiteContainer from '../../../components/Container/WhiteContainer';
import MasterDataDataGroupButton from '../../../components/MasterData/MasterDataDataGroupButton';
import API_MASTER_DATA from '../../../api/apiMasterData';

class DataScopeDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customer: {
                page: 1,
                limit: 10,
                data: [],
                isAll: false
            },
            principal: {
                page: 1,
                limit: 10,
                data: [],
                isAll: false
            }
        }
    }

    getFilterCustomer = id => {
        API_MASTER_DATA.getFilterDistributorDataGroup(this.state.customer.page, this.state.customer.limit, id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let customerList = getContent(res).map(customer => ({
                        value: customer.user_nexcare_id,
                        label: customer.customer_name
                    }))
                    this.setState({
                        customer: {
                            ...this.state.customer,
                            data: customerList
                        }
                    })
                }
            })
    }

    getFilterPrincipal = id => {
        API_MASTER_DATA.getFilterPrincipalDataGroup(this.state.principal.page, this.state.principal.limit, id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let principalList = getContent(res).map(principal => ({
                        value: principal.user_nexcare_id,
                        label: principal.customer_name
                    }))
                    this.setState({
                        principal: {
                            ...this.state.principal,
                            data: principalList
                        }
                    })
                }
            })
    }

    componentDidMount() {
        this._isMounted = true;

        if (this.props.data.scope?.['nexsoft']?.[0] === 'all') {
            return this.setState({
                customer: {
                    ...this.state.customer,
                    isAll: true
                },
                principal: {
                    ...this.state.principal,
                    isAll: true
                }
            })
        }

        if (this.props.data?.scope['nexsoft.user_customer.cust']?.[0] === 'all') {
            this.setState({
                customer: {
                    ...this.state.customer,
                    isAll: true
                }
            })
        }

        if (this.props.data?.scope['nexsoft.user_customer.pr']?.[0] === 'all') {
            this.setState({
                principal: {
                    ...this.state.principal,
                    isAll: true
                }
            })
        }

        if (this.props.data.scope['nexsoft.user_customer.cust'] !== undefined) {
            const customerId = this.props.data?.scope['nexsoft.user_customer.cust'].join(', ')
            this.getFilterCustomer(customerId);
        }

        if (this.props.data.scope['nexsoft.user_customer.pr'] !== undefined) {
            const principalId = this.props.data?.scope['nexsoft.user_customer.pr'].join(', ')
            this.getFilterPrincipal(principalId);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const animatedComponents = makeAnimated();

        return (
            <div>
                <MasterDataDataGroupButton
                    dataScopePage={this.props.dataScopePage}
                    handleDataGroup={this.props.handleDataGroup}
                    handleDataScope={this.props.handleDataScope}
                />
                <WhiteContainer>
                    <div className="flex">
                        <div className="w-1/2 p-10 kiri">
                            <div className="flex justify-between w-full mb-5">
                                <div className="w-1/6 pr-5 text-right">
                                    <label className="select-none font-medium text-gray-400" htmlFor="mlscustomername">Nama Distributor</label>
                                </div>
                                <div className="w-5/6">
                                    <Select
                                        id="mlscustomername"
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        placeholder="Pilih Distributor"
                                        isDisabled={true}
                                        value={this.state.customer.data}
                                        isMulti
                                    />
                                    <div className="mt-5 text-gray-400 font-medium">
                                        <input type="checkbox" id="ckballcustomer" className="mr-2" checked={this.state.customer.isAll} disabled />
                                        <label htmlFor="ckballcustomer">Terapkan Semua</label>
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-between w-full mb-5">
                                <div className="w-1/6 pr-5 text-right">
                                    <label className="select-none font-medium text-gray-400" htmlFor="mlsprincipalname">Nama Principal</label>
                                </div>
                                <div className="w-5/6">
                                    <Select
                                        id="mlsprincipalname"
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        placeholder="Pilih Principal"
                                        isDisabled={true}
                                        value={this.state.principal.data}
                                        isMulti
                                    />
                                    <div className="mt-5 text-gray-400 font-medium">
                                        <input type="checkbox" id="ckballprincipal" className="mr-2" checked={this.state.principal.isAll} disabled />
                                        <label htmlFor="ckballprincipal">Terapkan Semua</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button
                        type="button"
                        id="btnclose"
                        className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2 absolute bottom-5 right-5"
                        onClick={() => this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP)}
                    >
                        Tutup
                    </button>
                </WhiteContainer>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default withRouter(connect(mapStateToProps, null)(DataScopeDetail));